import { Routes, RouterModule } from '@angular/router';
import { GenerarReporteUACComponent } from './generar-reporte-UAC.component';
import { NgModule } from '@angular/core';

const routes: Routes = [
  { path: '', component: GenerarReporteUACComponent }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})

export class GenerarReporteUACRouting { }
